import React from 'react'

import { ArrowDown, ArrowUp } from '@fsg/icons'
import { cn } from '@app/utils'

type Props = {
  arrow?: 'up' | 'down'
  color?: 'red' | 'green'
  className?: string
  label: string | number
  labelClass?: string
}

export function Flag(props: Props) {
  const { arrow, color, label, labelClass, className } = props

  return (
    <div
      className={cn(
        'min-w-[40px] rounded-full px-xs py-4xs text-center text-[12px] font-bold',
        {
          'bg-gray-200': color === undefined,
          'bg-green-100 text-green-800': color === 'green',
          'bg-red-100 text-red-800': color === 'red',
        },
        className,
      )}
    >
      {arrow ? arrow === 'up' ? <ArrowUp className="inline" /> : <ArrowDown className="inline" /> : null}
      <span className={labelClass}>{label}</span>
    </div>
  )
}
